import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-slate-50 border-y border-amber-500/30" data-id="element-281" data-mp="3sq1vbv6hrw06">
      <div className="max-w-7xl mx-auto px-4" data-id="element-282" data-mp="3ssemmyy53ipw">
        <div className="text-center mb-7" data-id="element-283" data-mp="3nzbnmbalfh2b">
          <h2 className="text-blue-950 font-bold tracking-widest uppercase text-sm" data-id="element-284" data-mp="3nxihqy7t10vd">
            ⭐ What Olympic Weightlifting Coaches Are Saying
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-285" data-mp="lpw9hlnu5de">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-amber-500/40 p-6 rounded-2xl shadow-sm shadow-blue-700/10 flex flex-col" data-id="element-286" data-mp="fj0gbfcdcjkq" data-mpi={index}>
              <div className="flex gap-1 text-amber-500 mb-4" aria-label="5 out of 5 stars" data-id="element-287" data-mp="cawbgcef0h5a">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-288" data-mp="lclyz756evxs" data-mpi={starIndex} />)}
              </div>
              <blockquote className="text-slate-700 italic mb-6 text-sm leading-relaxed" data-id="element-289" data-mp="q5ov9n1c8jho">
                “{testimonial.text}”
              </blockquote>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-amber-500/20" data-id="element-290" data-mp="1021okjsz0vbw">
                <div className="w-11 h-11 rounded-full bg-blue-950 flex items-center justify-center text-amber-500 font-bold text-sm shrink-0" aria-hidden="true" data-id="element-291" data-mp="14453jieumi1x">
                  {testimonial.initials}
                </div>
                <div className="min-w-0" data-id="element-292" data-mp="35xmjd9d4up7r">
                  <div className="font-bold text-blue-950 text-sm" data-id="element-293" data-mp="3ave9bxu7w19b">{testimonial.name}</div>
                  <div className="text-xs text-slate-500" data-id="element-294" data-mp="hz2z1hmjfw92">
                    {testimonial.role} — {testimonial.location}
                  </div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}